export const environment = {
  production: false,
   apiUrl: 'https://appservicioscarvest2.test.einteligent.com/api'
  //apiUrl: 'https://localhost:44337/api',
};